import { ReactionTypeEntity } from "../../services/gc/types/reactionTypeEntity";

export type MessageReaction = {
  clientId: string;
  reaction: ReactionTypeEntity;
};

export interface UserChatMessageProps extends UserChatProps {
  reactions?: Record<string, MessageReaction[]>;
}

export interface UserChatProps {
  username?: string;
  isGold?: boolean;
  avatar?: string;
  isAdmin?: boolean;
  isGuest?: boolean;
  guestIcon?: string;
}

export class ModerationError extends Error {
  categories: string[];

  constructor(categories: string[]) {
    super("Message blocked by moderation");
    this.name = "ModerationError";
    this.categories = categories;
  }
}

export function getModerationErrorMessage(categories: string[]): string {
  if (categories.includes("external_link")) {
    return "Your message was removed because external links are not allowed.";
  }
  return "Your message was removed for violating our community guidelines.";
}
